/**
 * Формати показу дати — єдине джерело для всього застосунку.
 *
 * Їх бере ядро (`AppConfig.dateDefaultFormat` / `datetimeDefaultFormat`:
 * таблиці, поля дати, фільтри) і Ship (`Helpers/fieldViews`: картки, журнал,
 * стрічки). Рішення замовника 2026-10-14 — усюди ДД.ММ.РРРР, як в Астеріксі.
 *
 * Це формат **лише показу**. На бек дата йде ISO: поле — `dayjs().format()`
 * (ATOM) у `DateFieldStrategy` і `DatePickerInput`, фільтр — `YYYY-MM-DD
 * HH:mm:ss` у `ListRequestTransformerTask`; від цих констант вони не залежать.
 */

/** «14.10.2026» */
export const DATE_FORMAT = 'DD.MM.YYYY'

/** «14.10.2026, 13:57» */
export const DATETIME_FORMAT = 'DD.MM.YYYY, HH:mm'
